import { ReactNode } from "react";
import { Stack, useTheme } from "@mui/material";
import { TiledBackground } from "../theme/background";

interface BelowBarProps {
    children: ReactNode[] | ReactNode;
    topbarHeight: number;
}

export const BelowBar = (props: BelowBarProps) => {
    const theme = useTheme();

    return (
        <Stack
            direction={"row"}
            alignItems={"center"}
            spacing={2}
            sx={{
                backgroundColor: theme.bee.barBackground
            }}>

            <TiledBackground offset={props.topbarHeight} />
            {props.children}
        </Stack>
    )
}